<body>
  <div class="dash">
    <app-sidebar></app-sidebar>
    <div class="dash-app">
      <app-header></app-header>
      <main class="dash-content" style="padding: 0; margin: 0">
        <div class="container-fluid">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                <div class="panel panel-white profile-widget">
                  <div>
                    <form
                      style="padding-left:80px;padding-right: 80px"
                      class="form-horizontal"
                      [formGroup]="newcdForm"
                      (ngSubmit)="onSubmitnewClinicData()"
                    >
                      <h5 style="text-align: center">Add Clinic</h5>
                      <!-- <hr />
                      <div class="col-12"><h4>Is Hospital</h4></div> <div class="col-9"><input type="checkbox" (click)="isHospitalCheck(true)" [checked]="isHospitalT"> True</div>
                      <div class="col-3"></div> <div class="col-9 " style="padding-bottom: 10px;"><input type="checkbox" (click)="isHospitalCheck(false)" [checked]="isHospitalF">Flase</div>
                      <hr /> -->
                      <div  class="form-row">
                      <div class="form-group col-md-6">
                        <label for="name">Clinic Name</label>
                        <input
                          type="text"
                          id="name"
                          placeholder="Clinic name"
                          class="form-control"
                          formControlName="clinicName"
                          autofocus
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="bookingType">Please select bookingType*</label>
                        <select
                          class="form-control"
                          id="bookingType"
                          formControlName="bookingType"
                        >
                          <option value="SD">Single day bookingType</option>
                          <option value="MD">Multiple days bookingType</option>
                        </select>
                        <div class="col-md-12">
                          <p><b>Note:</b>(1). Single day bookingType valid for a day.<br>(2). Multiple days bookingType valid for five days.
                          </p>
                        </div>
                      </div>
                      </div>
                       <!-- Hospital Side 
                      <div *ngIf="isHospitalT" class="form-row">
                        <div class="form-group col-md-6">
                          <label for="weekDays">Choice A Hospital</label>
                            <select
                            class="form-control"
                            id="state"
                            formControlName="state"
                          >
                            <option value="AP">Andhra Pradesh</option>
                            <option value="AR">Arunachal Pradesh</option>
                            <option value="AS">Assam</option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="patientLimit"
                            >Patient Limit(per day)</label
                          >
                          <input
                            type="number"
                            id="name"
                            placeholder="Enter patient limit"
                            class="form-control"
                            formControlName="patientLimit"
                          />
                        </div>
                      </div>
                      <div *ngIf="isHospitalT" class="form-row">
                        <div class="form-group col-md-6">
                          <label for="startTime">Opening Time</label>
                          <input
                            type="time"
                            name="starttime"
                            class="form-control"
                            formControlName="startTime"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="endTime">Closing Time </label>
                          <input
                            type="time"
                            name="starttime"
                            class="form-control"
                            formControlName="endTime"
                          />
                        </div>
                      </div>
                       End Hospital Side  -->

                      <div  class="form-row">
                        <div class="form-group col-md-6">
                          <label for="weekDays">Working Days</label>

                          <!-- <div class="col-sm-10 offset-md-1"> -->
                          <p-multiSelect
                            [options]="clinicDays"
                            formControlName="weekDays"
                            inputStyleClass="form-control"
                            autoWidth="false"
                            [style]="{ width: '100%' }"
                          ></p-multiSelect>
                          <!-- </div> -->
                        </div>

                        <div class="form-group col-md-6">
                          <label for="patientLimit"
                            >Patient Limit(per day)</label
                          >
                          <!-- <div class="col-sm-10 offset-md-1"> -->
                          <input
                            type="number"
                            id="name"
                            placeholder="Enter patient limit"
                            class="form-control"
                            formControlName="patientLimit"
                          />
                          <!-- </div> -->
                        </div>
                      </div>

                      <div  class="form-row">
                        <div class="form-group col-md-6">
                          <label for="startTime">Opening Time</label>
                          <input
                            type="time"
                            name="starttime"
                            class="form-control"
                            formControlName="startTime"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="endTime">Closing Time </label>
                          <input
                            type="time"
                            name="starttime"
                            class="form-control"
                            formControlName="endTime"
                          />
                        </div>
                      </div>

                      <div  class="form-group">
                        <label for="address">Address*</label>
                        <textarea
                          type="text"
                          id="address"
                          placeholder="Address"
                          class="form-control"
                          formControlName="line1"
                        ></textarea>
                      </div>

                      <div  class="form-row">
                        <div class="form-group col-md-6">
                          <label for="city">District*</label>
                          <input
                            type="text"
                            id="city"
                            placeholder="district"
                            class="form-control"
                            formControlName="district"
                          />
                        </div>

                        <div  class="form-group col-md-6">
                          <label for="city">City*</label>

                          <input
                            type="text"
                            id="city"
                            placeholder="City"
                            class="form-control"
                            formControlName="city"
                          />
                        </div>
                      </div>

                      <div  class="form-row">
                        <div class="form-group col-md-6">
                          <label for="state">State*</label>
                          <select
                            class="form-control"
                            id="state"
                            formControlName="state"
                          >
                            <option value="AP">Andhra Pradesh</option>
                            <option value="AR">Arunachal Pradesh</option>
                            <option value="AS">Assam</option>
                            <option value="BR">Bihar</option>
                            <option value="CG">Chhattisgarh</option>
                            <option value="GA">Goa</option>
                            <option value="GJ">Gujrat</option>
                            <option value="HR">Haryana</option>
                            <option value="HP">Himachal Pradesh</option>
                            <option value="JH">Jharkand</option>
                            <option value="KA">Karnataka</option>
                            <option value="KL">Kerla</option>
                            <option value="MP">Madhya Pradesh</option>
                            <option value="MH">Maharashtra</option>
                            <option value="MN">Manipur</option>
                            <option value="ML">Meghalaya</option>
                            <option value="MZ">Mizoram</option>
                            <option value="NL">Nagaland</option>
                            <option value="OD">Odisha</option>
                            <option value="PB">Punjab</option>
                            <option value="RJ">Rajasthan</option>
                            <option value="SK">Sikkim</option>
                            <option value="TN">Tamil Nadu</option>
                            <option value="TS">Telangana</option>
                            <option value="TR">Tripura</option>
                            <option value="UP">Uttar Pradesh</option>
                            <option value="UK">Uttarakhand</option>
                            <option value="WB">West Bengal</option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="pincode">PinCode*</label>
                          <input
                            type="text"
                            id="pincode"
                            placeholder="Pincode"
                            class="form-control"
                            formControlName="pincode"
                          />
                        </div>
                      </div>

                      <div class="col-sm-9 offset-md-1">
                        <button
                          class="btn btn-primary btn-block"
                          style="border-radius: 10px"
                          type="submit"
                          [disabled]="isLoading"
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            *ngIf="isLoading"
                          ></span>

                          Add Clinic
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</body>